var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Header"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/view/images/logo.png"),"alt":""},on:{"click":_vm.TOPortal}})])}
var staticRenderFns = []

export { render, staticRenderFns }